import { Component } from '@angular/core';

import {NewNavigationService} from "@shared/services/new-navigation.service";

@Component({
  selector: 'sm-server-timeout-dialog',
  templateUrl: './server-timeout-dialog.component.html',
})
export class ServerTimeoutDialogComponent  {

  constructor(
    private newNavigationService: NewNavigationService
  ) {
  }

  onSubmit() {
    this.newNavigationService.toLogout();
  }
}
